import React, { useState, useEffect } from "react";

import HelpSpinners from "components/spinners";
import { Grid, _ } from "gridjs-react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import ModalRegistro from "components/admin/modal/registro";

const Ventas = () => {
  const [url,setUrl]= useState()
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);

  const [tabla, setTabla] = useState([]);
  const [btnLoading,setBtnLoading] = useState(false)
  const handleClose = () => setShow(false);
 const [print,setPrint] = useState(false);
 const [showCompromiso,setShowCompromiso] = useState(false);
const [visible, setVisible] = useState(false)
const [showInputFilters,setShowInputFilters] = useState(false)
const [showMesayLugar,setShowMesayLugar] = useState(false)
  const [datos, setDatos] = useState({});
  const [selected,setSelected]= useState();
  
  const filtros = [{
    value: "lugarVotacion",
    name: "Vota en"},{
    value: "barrioResidencia",
    name: "Vive en"},{
    value: "compromiso",
    name: "Compromisos"},{
    value: "comunidad",
    name: "Comunidades"},{
    value: "Actual",
    name: "Tipo de cedulas"}, {
      value: "mesa",
      name: "Mesa de votacion"}
  ]

  const cambio = (e) => {
    const { name, value } = e.target;
   var input= document.getElementById("textInput")
   
   

if (name ==="filtro") {
  setDatos({})
  
  if( input !== null){
    input.value="";
   }
  if (value !=="mesa" & value !== "compromiso") {
    setSelected(value)
    setShowInputFilters(true)
    
  }else{
    setSelected(null)
    setShowInputFilters(false)
  }

  if(value==="mesa"){
    setShowMesayLugar(true);
    
  }else{
    setShowMesayLugar(false);
  }
  if(value==="compromiso"){
    setShowCompromiso(true);
   
  }else{
    setShowCompromiso(false);
  }
  
}else{
  setDatos({ ...datos, [name]: value });
}
setVisible(true);
   
  };
  

  const tablaF = async () => {
    const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/usuario.php`);
    const data = await res.json();
    setTabla(data);

    setLoading(false);
  };

  const search = async () => {
    setPrint(false);
  
    

    if( selected !==""){
      var queryString = Object.keys(datos).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(datos[key]);
    }).join("&");
    setUrl(queryString);
  
      
      setBtnLoading(true)
      const res = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/usuario.php`,
        {
          method:  "POST",
          body: JSON.stringify(datos),
        }
      );
      const data = await res.json();

  
      setTabla(data);
      setPrint(true);
      setBtnLoading(false)
      
    }
    
   
  };


 

  const History = useNavigate();

  const Deletelink = async (data) => {
    const alert = await Swal.fire({
      title: "Desea eliminar esto ?",
      text: data,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Eliminar",
    });
    if (alert.isConfirmed) {
      const data1 = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/usuario.php`,
        {
          method: "DELETE",
          body: data,
        }
      );
      const res = await data1.json();

      if (res.status === "ok") {
        Swal.fire({
          title: "",
          icon: "success",
          timer: 2000,
          toast: true,
          position: "top-end",
          width: "10rem",
          showConfirmButton: false,
        });
        tablaF();
      } else {
        Swal.fire("No se pudo eliminar");
      }
    } else {
      Swal.fire("-");
    }
  };
  useEffect(() => {
    tablaF();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="" style={{ height: "100vh", marginTop: "5%" }}>
      {loading ? (
        <div className="carga">
          <HelpSpinners loading={loading} size={300} />
        </div>
      ) : (
        <>
          <div className="container text-center mb-4">
            <div className="row justify-content-md-end ">
              <div
                className=" col-4 btn-group "
                role="group"
                aria-label="Basic example"
              >
                <button
                  type="button"
                  onClick={() => setShow(true)}
                  className="btn btn-primary"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    fill="currentColor"
                    class="bi bi-person-add"
                    viewBox="0 0 16 16"
                  >
                    <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0Zm-2-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
                    <path d="M8.256 14a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Z" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-3">
            <select
                    onChange={cambio}
                    className="form-select"
                    name="filtro"
                    id="filtro"
                    required
                  >
                    <option selected value={0}>
                     Filtros
                    </option>
                    {
                      filtros.map((dt)=>{
                        return( <option value={dt.value}>{dt.name}</option>)
                      })
                    }
                   
                    </select>
            </div>
            {
              showInputFilters ? (<div className="col-3">
              <input
                      type="text"
                      name={selected}
                      onChange={cambio}
                      id="textInput"
                      className={` form-control`}
                  
                    />
                
  
              </div>):(<></>)
            }
            {
              showCompromiso ? (<div className="col-3">
              
              <select
                onChange={cambio}
                className="form-select"
                name="compromiso"

              >
                <option selected value={0}>
                 Compromisos
                </option>
                <option value="pendiente">pendiente</option>
                <option value="cumplido">cumplido</option>
                <option value="Al llegar">Al llegar</option>
                <option value="Dia de">Dia de</option>
              </select>
             
            </div>): (<></>)
            }
            {
              showMesayLugar ? (<><div className="col-2">
              <input
                      type="number"
                      name="mesa"
                      onChange={cambio}
                      className={` form-control`}
                    
                      placeholder="mesa de votacion"
                    />
                
  
              </div>
              <div className="col-3">
              
                    <select
                      onChange={cambio}
                      className="form-select"
                      name="lugarVotacion"
                      id="lugarVotacion"
                      required
                    >
                      <option selected value={0}>
                        Lugar de votacion
                      </option>
                      <option value="lloro">Lloro</option>
                      <option value="quibdo">Quibdo</option>
                      <option value="La vuelta">La vuelta</option>
                      <option value="Boraudo">Boraudo</option>
                      <option value="Villa Claret">Villa Claret</option>
                      <option value="Las hamacas">Las hamacas</option>
                      <option value="Villa Nueva">Villa Nueva</option>
                      <option value="La playa">La playa</option>
                      <option value="Guaitado">Guaitado</option>
                      <option value="Nipurdu">Nipurdu</option>
                      <option value="Tumutumbudo">Tumutumbudo</option>
                    </select>
                  </div></>):(<></>)
            }
            
{
  visible ? (<>  <div style={{
    width:"49px"
  }} className="col-2 ">
  <button
      type="button"
      onClick={search}
      className={`btn btn-primary `}
    >
      {
        btnLoading ? (<><div className="spinner-border spinner-border-sm" role="status">
       
      </div></>):( <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        class="bi bi-search"
        viewBox="0 0 16 16"
      >
        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
      </svg>)
      }
     
    </button>
  </div>

 </>) : (<></>)
}
{
  print ? ( <div className="col-2">
  <a
        type="button"
        href={`${process.env.REACT_APP_SERVER_URL}/reportes/reportesGeneral.php?${url}`}
        target="_black"
        className={`btn btn-danger `}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-filetype-pdf"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z"
          />
        </svg>
      </a>
  </div>): (<></>)
}
              

            </div>

           

     
       

          <ModalRegistro
            show={show}
            tabla={tablaF}
            setShow={setShow}
            handleClose={handleClose}
          />
          <Grid
            data={tabla}
            resizable={true}
            columns={[
              {
                id: "id_persona",
                name: "#",
                width: "5%",
              },
              {
                id: "cedula",
                name: "Cedula",
                width: "10%",
              },
              {
                id: "nombre",
                name: "Nombre",
              },

              {
                id: "apellido",
                name: "Apellido",
              },

              {
                id: "Telefono",
                name: "Telefono",
              },
              {
                id: "mesa",
                name: "Mesa votacion",
                width: "10%",
              },
              {
                id: "lugarVotacion",
                name: "Lugar de votacion",
              },
              {
                name: "Actions",
                width: "14%",
                formatter: (cell, row) =>
                  _(
                    <div
                      className="btn-group"
                      role="group"
                      aria-label="Basic example"
                    >
                      <button
                        className={"btn btn-danger"}
                        title="Eliminar usuario"
                        onClick={() => Deletelink(row.cells[0].data)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-person-dash-fill"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M11 7.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5z"
                          />
                          <path d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                        </svg>
                      </button>
                      <button
                        className={"btn btn-primary"}
                        title="Editar usuario"
                        onClick={() =>
                          History(`/usuario/${`${row.cells[0].data}`}`)
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-pencil-square"
                          viewBox="0 0 16 16"
                        >
                          <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                          <path
                            fill-rule="evenodd"
                            d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                          />
                        </svg>
                      </button>
                      <button
                        className={"btn btn-warning"}
                        title="ver informacion completa"
                        onClick={() =>
                          History(`/info/${`${row.cells[0].data}`}`)
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-eye"
                          viewBox="0 0 16 16"
                        >
                          <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                          <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                        </svg>
                      </button>
                    </div>
                  ),
              },
            ]}
            search={true}
            pagination={{
              enabled: true,
              limit: 10,
            }}
          />
        </>
      )}
    </div>
  );
};
export default Ventas;
